<script setup lang="ts">
import { onMounted } from 'vue'

defineProps<{
  adSlot: string
}>()

const isDevelopment = import.meta.env.SSR ? true : (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
const adClient = 'ca-pub-9066544714340882' // Your production AdSense publisher ID

onMounted(() => {
  // Only initialize ads in production (AdSense won't work on localhost)
  if (!isDevelopment) {
    try {
      ;(window as any).adsbygoogle = (window as any).adsbygoogle || []
      ;(window as any).adsbygoogle.push({})
    } catch (e) {
      if (import.meta.env.DEV) console.error('AdSense error:', e)
    }
  }
})
</script>

<template>
  <div class="ad-box">
    <!-- Development placeholder -->
    <div v-if="isDevelopment" class="ad-placeholder">
      <div class="ad-placeholder-content">
        <span class="ad-placeholder-icon">📢</span>
        <span class="ad-placeholder-text">Ad Placeholder</span>
        <span class="ad-placeholder-slot">Slot: {{ adSlot }}</span>
      </div>
    </div>
    
    <!-- Production AdSense -->
    <ins
      v-else
      class="adsbygoogle"
      style="display: block"
      :data-ad-client="adClient"
      :data-ad-slot="adSlot"
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  </div>
</template>

<style scoped>
.ad-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 100%;
  min-height: 250px;
  margin: 1rem 0;
  /* CSS containment to prevent layout shift from ad loading */
  contain: layout style;
  /* Reserve space even if ad fails to load */
  box-sizing: border-box;
  overflow: hidden;
}

.ad-box ins {
  width: 100% !important;
  max-width: 100%;
  min-height: 250px;
  display: block;
}

/* Development placeholder styles */
.ad-placeholder {
  width: 100%;
  min-height: 250px;
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  border: 2px dashed #475569;
  border-radius: var(--radius-md);
  display: flex;
  justify-content: center;
  align-items: center;
}

.ad-placeholder-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  color: #94a3b8;
}

.ad-placeholder-icon {
  font-size: 2rem;
}

.ad-placeholder-text {
  font-size: 1rem;
  font-weight: 600;
  color: #e2e8f0;
}

.ad-placeholder-slot {
  font-size: 0.75rem;
  font-family: monospace;
  background: #0f172a;
  padding: 0.25rem 0.5rem;
  border-radius: var(--radius-sm);
  color: #f59e0b;
}
</style>
